import TournamentPage from "./TournamentPage"

export default TournamentPage
